import {
  IMentionAttachmentCommentData,
  IInventoryAdvancePaymentData,
  InventoryAdvancePaymentFilterParams,
  InventoryAdvancePaymentStatusEnum,
  IAttachmentData
} from '@/models';
import { Transition } from '@/models/transition';
import { IUserData } from '@vue-altoleap-libraries/vue-altoleap-accounts-lib/types/model/userData.types';

export interface IInventoryAdvancePaymentPaginatedListData {
  count: number;
  next?: string;
  previous?: string;
  results: IInventoryAdvancePaymentData[];
}

export interface IInventoryAdvancePaymentExportFilterParams
  extends InventoryAdvancePaymentFilterParams {
  search?: string;
}

export interface IInventoryAdvancePaymentFilterParam
  extends InventoryAdvancePaymentFilterParams {
  page?: number;
  search?: string;
}

export interface IInventoryAdvancePaymentUpdateState {
  id: number;
  state: InventoryAdvancePaymentStatusEnum;
  assignee?: number;
  comment?: string;
}

export interface IInventoryAdvancePaymentService {
  fetchInventoryAdvancePayments(
    filter?: IInventoryAdvancePaymentFilterParam
  ): Promise<IInventoryAdvancePaymentPaginatedListData>;
  fetchInventoryAdvancePayment(
    id: number
  ): Promise<IInventoryAdvancePaymentData>;
  createInventoryAdvancePayment(
    data: IInventoryAdvancePaymentData
  ): Promise<IInventoryAdvancePaymentData>;
  updateInventoryAdvancePayment(
    data: IInventoryAdvancePaymentData
  ): Promise<IInventoryAdvancePaymentData>;
  deleteInventoryAdvancePayment(id: number): Promise<any>;
  deleteInventoryAdvancePaymentAttachment(
    inventoryAdvancePaymentId: number,
    attachmentId: number
  ): Promise<any>;
  addInventoryAdvancePaymentAttachments(
    id: number,
    attachments: File[]
  ): Promise<any>;
  updateInventoryAdvancePaymentState(
    data: IInventoryAdvancePaymentUpdateState
  ): Promise<IInventoryAdvancePaymentData>;

  fetchCurrentAvailableAssignees(id: number): Promise<IUserData[]>;

  fetchInventoryAdvancePaymentFinanceManagers(id: number): Promise<IUserData[]>;
  assignInventoryAdvancePaymentFinanceManager(
    id: number,
    financeManager: number
  ): Promise<IInventoryAdvancePaymentData>;

  fetchInventoryAdvancePaymentAPSpecialists(id: number): Promise<IUserData[]>;
  assignInventoryAdvancePaymentAPSpecialist(
    id: number,
    apSpecialist: number
  ): Promise<IInventoryAdvancePaymentData>;

  fetchInventoryAdvancePaymentApprovers(id: number): Promise<IUserData[]>;

  assignInventoryAdvancePaymentApprover(
    id: number,
    approver: number
  ): Promise<IInventoryAdvancePaymentData>;

  updateInventoryAdvancePaymentOwner(
    id: number,
    owner: number
  ): Promise<IInventoryAdvancePaymentData>;

  fetchInventoryAdvancePaymentActivities(id: number): Promise<Transition[]>;

  //comments
  fetchInventoryAdvancePaymentComments(
    inventoryAdvancePaymentId: number
  ): Promise<IInventoryAdvancePaymentData[]>;

  fetchInventoryAdvancePaymentComment(
    inventoryAdvancePaymentId: number,
    commentId: number
  ): Promise<IInventoryAdvancePaymentData>;

  createInventoryAdvancePaymentComment(
    inventoryAdvancePaymentId: number,
    comment: IMentionAttachmentCommentData
  ): Promise<IInventoryAdvancePaymentData>;

  updateInventoryAdvancePaymentComment(
    inventoryAdvancePaymentId: number,
    comment: IMentionAttachmentCommentData
  ): Promise<IInventoryAdvancePaymentData>;

  deleteInventoryAdvancePaymentComment(
    inventoryAdvancePaymentId: number,
    commentId: number
  ): Promise<void>;

  addInventoryAdvancePaymentCommentAttachments(
    timeOffId: number,
    commentId: number,
    attachments: IAttachmentData[]
  ): Promise<IMentionAttachmentCommentData>;

  removeInventoryAdvancePaymentCommentAttachment(
    timeOffId: number,
    commentId: number,
    attachmentId: number
  ): Promise<void>;

  fetchInventoryAdvancePaymentCommentsMentionableUsers(
    timeOffId: number
  ): Promise<IUserData[]>;

  //export payment inventoryAdvancePayment pdf
  exportInventoryAdvancePaymentPdf(
    inventoryAdvancePaymentId: number
  ): Promise<Blob>;
  exportInventoryAdvancePayments(
    params?: IInventoryAdvancePaymentExportFilterParams
  ): Promise<Blob>;

  updateMultipleInventoryAdvancePaymentOwner(
    owner: number,
    requisitions: number[]
  ): Promise<void>;
}

export const INVENTORY_ADVANCE_PAYMENT_EXPORT_TIMEOUT_IN_MILLISECONDS =
  30 * 1000;
